import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getOfferMerchants,
  getMerchants,
  getMerchantInquiries,
  toggleMerchantStatus,
  redeemOffer,
  fetchNewCustomerOffers,
  fetchOfferViewsClicks,
  getFavouriteOffers,
  getAboutPageViews,
  getDashboardStats,
  getRedemptionByDemographics,
  getRedemptionRates,
  getRedeemedFrequencies,
  approveOrRejectMerchant,
  getMerchantProfiles,
  getMerchantBusinessProfile,
  updateMerchantBusinessProfile,
  getMerchantById
} from "../../services/merchantService";
import toast from "../../utils/toast";

const initialState = {
  offerMerchants: null,
  merchants: null,
  inquiries: null,
  toggleMerchant: null,
  redeemedOffer: null,
  customerOffersData: null,
  offerViewsAndClicks: null,
  favouriteOffers: null,
  aboutPageViews: null,
  merchantDashboardStats: null,
  redemptionByDemographics: null,
  redemptionRates: null,
  statusUpdated: null,
  merchant: null,
  loading: false,
  selectedMerchent: null,
  merchantProfiles: null,
  merchantBusinessProfile: null,
  updateBusinessProfileResult: null,
};

const merchantSlice = createSlice({
  name: "merchant",
  initialState: initialState,
  reducers: {
    setCurrentBusiness: (state, action) => {
      state.selectedMerchent = action.payload;
      // Reset merchant-specific dashboard/cache so UI reflects the newly selected business
      state.merchantDashboardStats = null;
      state.offerViewsAndClicks = null;
      state.favouriteOffers = null;
      state.aboutPageViews = null;
      state.customerOffersData = null;
      state.redemptionByDemographics = null;
      state.redemptionRates = null;
      state.redemptionFrequencies = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOfferMerchants?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.offerMerchants = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getMerchants?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchants = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getMerchantInquiries?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.inquiries = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(toggleMerchantStatus?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.toggleMerchant = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(redeemOffer?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.redeemedOffer = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(fetchNewCustomerOffers?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.customerOffersData = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });
    builder.addCase(fetchOfferViewsClicks?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.offerViewsAndClicks = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getFavouriteOffers?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.favouriteOffers = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getAboutPageViews?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.aboutPageViews = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getDashboardStats?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchantDashboardStats = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getRedemptionByDemographics?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.redemptionByDemographics = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getRedemptionRates?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.redemptionRates = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getRedeemedFrequencies?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.redemptionFrequencies = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getMerchantProfiles?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchantProfiles = action?.payload;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getMerchantBusinessProfile.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchantBusinessProfile = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });
    builder.addCase(updateMerchantBusinessProfile.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.updateBusinessProfileResult = action?.payload?.data;
        state.merchantBusinessProfile = action?.payload?.data;
        toast.success(action?.payload?.message);
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(approveOrRejectMerchant?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.statusUpdated = action?.payload?.data;
        toast.success(action?.payload?.message, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getMerchantById?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchant = action?.payload?.data;
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder
      .addMatcher(
        isAnyOf(
          getOfferMerchants?.pending,
          getMerchants?.pending,
          getMerchantInquiries?.pending,
          toggleMerchantStatus?.pending,
          redeemOffer?.pending,
          fetchNewCustomerOffers?.pending,
          fetchOfferViewsClicks?.pending,
          getFavouriteOffers?.pending,
          getAboutPageViews?.pending,
          getDashboardStats?.pending,
          getRedemptionByDemographics?.pending,
          getRedemptionRates?.pending,
          getRedeemedFrequencies?.pending,
          approveOrRejectMerchant?.pending,
          getMerchantProfiles?.pending,
          getMerchantBusinessProfile.pending,
          updateMerchantBusinessProfile.pending
        ),
        (state, action) => {
          if (action?.meta?.arg?.silent === true) return;
          state.loading = true;
        }
      )
      .addMatcher(
        isAnyOf(
          getOfferMerchants?.rejected,
          getMerchants?.rejected,
          getMerchantInquiries?.rejected,
          toggleMerchantStatus?.rejected,
          redeemOffer?.rejected,
          fetchNewCustomerOffers?.rejected,
          fetchOfferViewsClicks?.rejected,
          getFavouriteOffers?.rejected,
          getAboutPageViews?.rejected,
          getDashboardStats?.rejected,
          getRedemptionByDemographics?.rejected,
          getRedemptionRates?.rejected,
          getRedeemedFrequencies?.rejected,
          approveOrRejectMerchant?.rejected,
          getMerchantProfiles?.rejected,
          getMerchantBusinessProfile.rejected,
          updateMerchantBusinessProfile.rejected
        ),
        (state, action) => {
          state.loading = false;
          toast.error(action?.payload?.message);
        }
      );
  },
});

export const { setCurrentBusiness } = merchantSlice?.actions;
export default merchantSlice?.reducer;
